import React from 'react'

function First() {
  return (
    <>
        <section className="project-detail">
            <div className="container">
                <div className="lower-content">
                <div className="row">
                    <div className="text-column col-lg-8 col-md-12 col-sm-12">
                    <div className="inner-column"> 
                        <div className="upper-box">
                        <div className="single-item-carousel owl-carousel owl-theme">
                            <figure className="image">
                            <img src="assets/img/gallery/protfolio-dt-img.png" alt="" />
                            </figure>
                        </div>
                        </div>
                        <h2>Project Description</h2>
                        <p>
                        Pleasure and praising pain was born and I will give you a complete
                        account of the systems, and expound the actually teachings of the
                        great explorer of the truth, the master-builder of human uts
                        happiness. No one rejects, dislikes, or avoids pleasure itself,
                        because it is pleasure, but because those who do not know how to
                        pursue pleasure rationally encounter that are extremely painful.
                        Nor again is there anyone who loves or pursues or desires to
                        obtain pain of itself pursues or desires to obtain pain of itself.
                        </p>
                        <h3>What We Did</h3>
                        <p>
                        Complete account of the systems and expound the actually teachings
                        of the great explorer of the truth, the master-builder of human
                        uts happiness. No one rejects, dislikes, or avoids pleasure
                        itself, because it is pleasure, but because those who do not know
                        how to pursue pleasure rationally encounter consequences that are
                        painful anyone who loves or pursues nyone who loves or pursues.
                        </p>
                        
                        <div className="two-column">
                        <div className="row">
                            <div className="image-column col-xl-6 col-lg-12 col-md-12">
                            <figure className="image">
                                <a href="assets/img/resource/post-img-1.jpg" className="lightbox-image" >
                                <img src="assets/img/resource/post-img-1.jpg" alt="" />
                                </a>
                            </figure>
                            </div>
                            <div className="text-column col-xl-6 col-lg-12 col-md-12">
                            <ul className="list-style-one">
                                <li>
                                Engine oil level should be regularly checked Tyres have a
                                minimum of 1.6mm of tread.
                                </li>
                                <li>
                                Ensure that the electrolyte level is correct Never remove
                                the radiator when the engine.
                                </li>
                                <li>
                                Ensure that your vehicle's brake fluid is full Engine oil
                                level should be regularly checked.
                                </li>
                                <li>
                                Sngine oil level should be regularly checked Tyres have a
                                minimum of 1.6mm of tread. E lectrolyte level is correct
                                Never remove.
                                </li>
                            </ul>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                    <div className="info-column col-lg-4 col-md-12 col-sm-12">
                    <div className="inner-column">
                        <h3>Project info</h3>
                        <p>
                        Pleasure and praising pain was born and I will give you a complete
                        account of the systems and the actually teachings of the great
                        explorer .
                        </p>
                        <ul className="project-info clearfix">
                        <li>
                            <span className="icon fa fa-user" />
                            <strong>Client</strong>
                            <p>Indu Designers</p>
                        </li>
                        <li>
                            <span className="icon fa fa-folder" />
                            <strong>Category</strong>
                            <p>Industrial</p>
                        </li>
                        <li>
                            <span className="icon fa fa-calendar-alt" />
                            <strong>Start Date</strong>
                            <p>28th Dec 2019</p>
                        </li>
                        <li>
                            <span className="icon far fa-calendar-alt" />
                            <strong>End Date</strong>
                            <p>28st Feb 2020</p>
                        </li>
                        <li>
                            <span className="icon fa fa-dollar-sign" />
                            <strong>Project Value</strong>
                            <p>$1250.00</p>
                        </li>
                        <li>
                            <span className="icon fa fa-paper-plane" />
                            <strong>Location</strong>
                            <p>Newyork City, USA</p>
                        </li>
                        </ul>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default First